export const config = {
  apiKey: 'AIzaSyA9vl-DV4W0qUz3eyEKbhDMzoTcU1twGuM',
  authDomain: 'kap-project-nsh-2504.firebaseapp.com',
  databaseURL: 'https://kap-project-nsh-2504-fdd2c.firebaseio.com/',
  projectId: 'kap-project-nsh-2504',
  storageBucket: 'kap-project-nsh-2504.appspot.com',
  messagingSenderId: '538060799891'
};

export const cryptrSecretKey = 'oberlin';
export const cryptrInitializationVector = '101112131415161718191a1b1c1d1e1f';



// WEBPACK FOOTER //
// ../shared-components/src/secrets.user.js